import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./themes/styles.scss";
import "./themes/adminstyles.scss";
import App from "./App";

import storeConfig from "./store/storeConfig";
import withClearCache from "./util/ClearCache";

const store = storeConfig();

const ClearCacheComponent = withClearCache(App);

let root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ClearCacheComponent />
    </BrowserRouter>
  </Provider>
);
